import { useEffect, useRef, useState } from 'react';
import { plural } from '@quadro/domain';
import { hud } from '../../components/Hud';
import { Icon } from '../../components/Icon';
import * as api from '../../data/api';
import { useTemplates } from '../../data/queries';
import { openSheet } from '../../state/sheets';

/** Botão "Modelos" ao lado da captura: escolher um modelo cria a tarefa e abre a ficha para ajustar. */
export function TemplatePicker() {
  const templates = useTemplates().data ?? [];
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const onDown = (e: MouseEvent) => { if (!ref.current?.contains(e.target as Node)) setOpen(false); };
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onDown); document.addEventListener('keydown', onKey);
    return () => { document.removeEventListener('mousedown', onDown); document.removeEventListener('keydown', onKey); };
  }, [open]);

  async function use(t: api.TaskTemplate) {
    setOpen(false);
    try {
      const { id } = await api.applyTemplate(t.id);
      hud(`Tarefa criada do modelo “${t.name}”`);
      openSheet({ kind: 'task', id });
    } catch (e) { hud((e as Error).message); }
  }

  return (
    <div className="tpk" ref={ref}>
      <button type="button" className="tpk-btn" aria-expanded={open} aria-haspopup="menu" onClick={() => setOpen(o => !o)}>Modelos<Icon name="chevR" /></button>
      {open && (
        <div className="tpk-pop" role="menu">
          {templates.map(t => (
            <button key={t.id} role="menuitem" type="button" onClick={() => use(t)}>
              <span className="tpk-n">{t.name}</span>
              <span className="muted">{t.subtasks.length ? plural(t.subtasks.length, 'subtarefa', 'subtarefas') : 'sem subtarefas'}</span>
            </button>
          ))}
          {!templates.length && <p className="muted tpk-empty">Nenhum modelo ainda.</p>}
          <button type="button" role="menuitem" className="tpk-manage" onClick={() => { setOpen(false); openSheet({ kind: 'templates' }); }}>Gerenciar modelos</button>
        </div>
      )}
    </div>
  );
}
